export default __webpack_public_path__ + "static/media/aplus-logo-only.86875d68.png";